import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import './Toast.scss';
import { ToastContainer } from './ToastContainer';
import { IconName, InlineIcon } from '@spark-labs/avocado-ui';

type ToastTypes = 'success' | 'warning' | 'error';
export interface ToastOptions {
  type?: ToastTypes;
  timeout?: number;
  textClass?: string;
  containerClass?: string;
  iconClass?: string;
  dismissable?: boolean;
  iconName?: IconName;
}
export const toast = (text: string, options: ToastOptions) => {
  const container = document.getElementById('toast-container');
  ReactDOM.render(<ToastContainer toastData={{ text, options }} />, container);

  return {
    hide: () => {
      if (container) {
        ReactDOM.unmountComponentAtNode(container);
      }
    },
  };
};
const defaultToastOptions: ToastOptions = {
  dismissable: true,
  timeout: 3500,
};
export const Toast: React.FC<{ options: ToastOptions; text: string; onHide: () => void }> = ({
  text,
  options,
  onHide,
}) => {
  const _options = { ...defaultToastOptions, ...options };
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    setTimeout(() => setVisible(true), 100);
    setTimeout(() => {
      if (_options.dismissable) {
        setVisible(false);
        onHide();
      }
    }, _options.timeout);
  }, []);

  return (
    <div className={`toast-wrapper`}>
      <div
        className={`toast ${
          visible ? 'visible' : ''
        } inline-flex items-center py-5 px-4 rounded ${getToastBackground(_options.type)} ${
          _options.containerClass
        }`}
      >
        {_options.iconName && (
          <InlineIcon name={_options.iconName} className={`${_options.iconClass}`} />
        )}
        <h4 className={_options.textClass}>{text}</h4>
      </div>
    </div>
  );
};

const getToastBackground = (type?: ToastTypes) => {
  if (type === 'error') return 'bg-red-light';
  if (type === 'warning') return 'bg-yellow-lighter';
  if (type === 'success') return 'bg-green text-white  ';
  return 'bg-grey-lighter';
};

toast.success = async (text: string, options?: ToastOptions) => {
  return toast(text, {
    containerClass: 'justify-center',
    textClass: 'text-white',
    iconName: 'check-circle',
    iconClass: 'text-lg mr-2 text-white',
    ...(options || {}),
    type: 'success',
  });
};

toast.error = async (text: string, options?: ToastOptions) => {
  return toast(text, {
    containerClass: 'justify-center',
    textClass: 'text-white',
    iconName: 'warning-triangle',
    iconClass: 'text-lg mr-2 text-white',
    ...(options || {}),
    type: 'error',
  });
};

toast.warning = async (text: string, options?: ToastOptions) => {
  return toast(text, {
    containerClass: 'justify-center',
    textClass: 'text-grey-dark',
    iconName: 'warning-triangle',
    iconClass: 'text-lg mr-2 text-grey-dark',
    ...(options || {}),
    type: 'warning',
  });
};
